import React from 'react';

export default class Sort extends React.Component {
	render() {
		return <div>Sort</div>;
	}
}
